export const activityModalContainerId = (guid: string): string =>
  `activity-modal-containerId${guid}`

export const makeAPaymentModalContainerId = (guid: string): string =>
  `make-a-payment-modal-containerId${guid}`

export const accountDetailsModalContainerId = (): string =>
  `account-details-modal-containerId`

export const statementsModalContainerId = (): string =>
  `statements-modal-containerId`

export const rewardsModalContainerId = (guid: string): string =>
  `rewards-modal-containerId${guid}`

export const creditLimitIncreaseContainerId = (guid: string): string =>
  `credit-limit-increase-modal-containerId${guid}`

export const manageCardHoldersModalContainerId = (guid: string): string =>
  `manage-card-holders-modal-containerId${guid}`

export const changePaymentDueDateModalContainerId = (guid: string): string =>
  `change-payment-due-date-modal-containerId${guid}`

export const creditBalanceRefundModalContainerId = (guid: string): string =>
  `credit-balance-refund-modal-containerId${guid}`

export const customCardArtModalContainerId = (guid: string): string =>
  `custom-card-art-modal-containerId${guid}`

export const digitalCollectionsContainerId = (guid: string): string =>
  `digital-collections-modal-containerId${guid}`

export const replaceYourCardModalContainerId = (guid: string): string =>
  `replace-your-card-modal-containerId${guid}`

export const cardStatusTrackerModalContainerId = (guid: string): string =>
  `card-status-tracker-modal-containerId${guid}`

export const paymentSecurityModalContainerId = (guid: string): string =>
  `payment-security-modal-containerId${guid}`
